import React from "react";
import {withState} from "@mna/react"
import TermsScreen from "../terms"

const NewTriage = (props) =><TermsScreen {...{...props}}/>;

export default NewTriage;
